function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import isEmpty from 'lodash/isEmpty';
import noop from 'lodash/noop';
import React, { useEffect, useRef, useState } from 'react';
import { Button as BootstrapButton, Overlay, Tooltip } from 'react-bootstrap';
import { PulseLoader } from 'react-spinners';
import useBreakpoint from '../../hooks/useBreakpoint';
import Icon from '../icon/Icon';
var variantSpinnerColorMap = function(variant) {
    switch(variant){
        case 'outline-primary':
            return '#027959';
        case 'disabled':
            return '#dcdcdc';
        default:
            return '#fff';
    }
};
var Button = function(_param) {
    var children = _param.children, loading = _param.loading, disabled = _param.disabled, icon = _param.icon, tooltipProps = _param.tooltipProps, variant = _param.variant, onClick = _param.onClick, rest = _object_without_properties(_param, [
        "children",
        "loading",
        "disabled",
        "icon",
        "tooltipProps",
        "variant",
        "onClick"
    ]);
    var target = useRef(null);
    var _useState = _sliced_to_array(useState(false), 2), isTooltipVisible = _useState[0], setIsTooltipVisible = _useState[1];
    var isEnabledForBreakpoint = useBreakpoint([
        'md',
        'lg',
        'xl'
    ]);
    var enableTooltip = !isEmpty(tooltipProps) && isEnabledForBreakpoint;
    useEffect(function() {
        if (rest.autoFocus && target.current) {
            // inevitable setTimeout on focus like implmentation in mapView.js --> focusSiteAddress();
            setTimeout(function() {
                var _target_current;
                return (_target_current = target.current) === null || _target_current === void 0 ? void 0 : _target_current.focus();
            }, 100);
        }
    }, [
        target.current,
        rest.autoFocus
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(BootstrapButton, _object_spread({
        onBlur: function() {
            return enableTooltip && setIsTooltipVisible(false);
        },
        onMouseEnter: function() {
            return enableTooltip && setIsTooltipVisible(true);
        },
        onMouseLeave: function() {
            return enableTooltip && setIsTooltipVisible(false);
        },
        ref: target,
        disabled: disabled,
        variant: variant,
        onClick: loading ? noop : onClick
    }, rest), loading ? /*#__PURE__*/ React.createElement(PulseLoader, {
        color: variantSpinnerColorMap(!disabled ? variant : 'disabled'),
        size: 12
    }) : /*#__PURE__*/ React.createElement(React.Fragment, null, icon && /*#__PURE__*/ React.createElement(Icon, {
        icon: icon
    }), children)), enableTooltip && /*#__PURE__*/ React.createElement(Overlay, {
        target: target.current,
        show: isTooltipVisible,
        placement: tooltipProps.placement
    }, function(props) {
        return /*#__PURE__*/ React.createElement(Tooltip, _object_spread({
            id: "button-tooltip"
        }, props), tooltipProps.text);
    }));
};
export default Button;
